export default __webpack_public_path__ + "static/media/female-after.7b4603ec.jpg";